(function () {
  const STORAGE_KEY = 'lambretta-wishlist';

  function getWishlist() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      active ? button.dataset.labelRemove : button.dataset.labelAdd
    );
  }

  function initWishlistButtons(root) {
    const wishlist = getWishlist();

    root.querySelectorAll('[data-lambretta-wishlist]').forEach((button) => {
      const handle = button.dataset.productHandle;
      if (!handle) return;

      setButtonState(button, wishlist.includes(handle));

      if (button.dataset.wishlistBound === 'true') return;
      button.dataset.wishlistBound = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const handles = getWishlist();
        const index = handles.indexOf(handle);
        const isActive = index === -1;

        if (isActive) {
          handles.push(handle);
        } else {
          handles.splice(index, 1);
        }

        saveWishlist(handles);
        setButtonState(button, isActive);
        button.blur();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initWishlistButtons(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initWishlistButtons(event.target);
  });
})();
